import get from "lodash/get";
import toLower from "lodash/toLower";
import React from "react";
import { getHost } from "util/api";

const FlagCell = ({
  data,
  column,
  style,
}: {
  data: any;
  column: any;
  style: React.CSSProperties & { fontSize: number };
}) => {
  const lifter = data.lifter;
  if (data.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else if (data.row === "title") {
    return <div style={style} className="table-cell-inner" />;
  } else {
    const country = toLower(get(lifter, "country"));
    const host = getHost();
    const imgStyle: React.CSSProperties = {};

    if (country) {
      imgStyle.height = "100%";
      imgStyle.width = "100%";
      imgStyle.backgroundImage = `url('${host}/flags/${country}.svg')`;
      imgStyle.backgroundSize = "contain";
      imgStyle.backgroundRepeat = "no-repeat";
      imgStyle.backgroundPosition = "top left";
    }

    return (
      <div style={style} className="table-cell-inner">
        {country && <div style={imgStyle} />}
      </div>
    );
  }
};

export default FlagCell;
